var map = {
	"./blackGold/footer/megaphone.png": 57504,
	"./brownGold/footer/megaphone.png": 50790,
	"./darkBlue/footer/megaphone.png": 17949,
	"./greenYellow/footer/megaphone.png": 88121,
	"./redGold/footer/megaphone.png": 28965,
	"./skyBlue/footer/megaphone.png": 52762,
	"./whiteGold/footer/megaphone.png": 99486,
	"./yellowWhite/footer/megaphone.png": 73176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12603;